import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import { useTranslation } from "react-i18next";
import TabLayout from "src/components/base/tab-layout";
import { Tab, TabMenu } from "src/components/base/tab-menu";
import Outlet from "src/components/base/outlet";

/**
 * The properties for {@link DnsTabs}
 */
export type DnsTabsProps = {};

/**
 * Tabs for DNS
 */
export default function DnsTabs(props: DnsTabsProps) {
    const [t] = useTranslation("admin-dns");

    return (
        <TabLayout
            heading={t("heading.dns")}
            tabs={
                <TabMenu>
                    <Tab href={"/a/dns/global"}>{t("heading.global")}</Tab>
                    <Tab href={"/a/dns/split"}>{t("heading.split")}</Tab>
                    <Tab href={"/a/dns/extra-records"}>{t("heading.extra-records")}</Tab>
                    <Tab href={"/a/dns/search-domains"}>{t("heading.search-domains")}</Tab>
                </TabMenu>
            }
        >
            <Outlet />
        </TabLayout>
    );
}

export const Route = createFileRoute("/_admin/a/dns/_dns")({
    component: DnsTabs,
});
